import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@store/hooks';
import type { ChildrenProps } from '@types';
import LoadingSpinner from './LoadingSpinner';

const AdminProtectedRoute = ({ children }: ChildrenProps) => {
  const { isAuthenticated, userProfile, isLoading } = useAppSelector(state => state.auth);

  if (isLoading) {
    return <LoadingSpinner fullScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!userProfile) {
    return <LoadingSpinner fullScreen />;
  }

  if (userProfile.role !== 'admin') {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default AdminProtectedRoute;
